export const SOCIAL_CARD_TYPE = {
    TEXT: 0,
    TWITTER: 1,
    LINKEDIN: 2,
    // FACEBOOK: 3,
    // G2: 4,
    REDDIT: 5,
    PLAYSTORE: 6,
    APPSTORE: 7,
    PRODUCTHUNT: 8,
    VIDEO: 9,
    TRUSTPILOT: 10,
    G2: 11,
    CAPTERRA: 12,
    SHOPIFY: 13,
    FACEBOOK: 14,
    SLACK: 15,
    AMAZON: 16,
    PICTURE: 17,
    GOOGLE: 18,
    DISCORD: 19,
    YOUTUBE: 20,
    INSTAGRAM: 21,
    AUDIO: 22,
    TELEGRAM: 23,
    WHATSAPP: 24,
    GOODFIRMS: 25,
    CLUTCH: 26,
    YELP: 27,
    DESIGNRUSH: 28,
    AIRBNB: 29,
    TRIPADVISOR: 30,
    BOOKING: 31,
    TIKTOK: 32,
    SKOOL: 41
}

export const socialCardKeys = {
    socialCardType: 'social_card_type',
    uuid: 'uuid',
    wallUuid: 'wall_uuid',
    authorName: 'author_name',  
    authorLink: 'author_link',
    authorUsername: 'author_username',
    authorImage: 'author_image',
    isAuthorMaker: 'is_author_maker',
    authorTagline: 'author_tagline',
    isAuthorImageInline: 'is_author_image_inline',
    authorIsVerifiedBadge: 'author_is_verified_badge',
    messageMediaImage: 'message_media_image',
    isMessageMediaImageInline: 'is_message_media_image_inline',
    customThumbnailUrl: 'custom_thumbnail_url',

    messageContent: 'message_content',
    messageLink: 'message_link',
    messageTime: 'message_time',
    upvotesCount: 'upvotes_count',
    starRating: 'star_rating',
    likesCount: 'likes_count',
    commentsCount: 'comments_count',
    owner: 'owner',
    workTitle: 'work_title',
    videoSummary: 'video_summary',
    sourcePlatform: 'source_platform',
    videoEmbedUrl: 'video_embed_url',

    videoPlaybackId: 'video_playback_id',
    screenshotImage: 'screenshot_image',
    screenshotImageUuid: 'screenshot_image_uuid',

    audioAssetUrl: 'audio_asset_url',
    audioAssetKey: 'audio_asset_key',

    isMediaVideoTwitterType: 'is_media_video_twitter_type',
    messageVideoThumbnail: 'message_video_thumbnail',
  };
